module.exports = __webpack_public_path__ + "assets/img/loading.6b04ff37.gif";